const SET_CAROUSEL = "SET_CAROUSEL";
const SET_MOVIELIST = "SET_MOVIELIST";

// quanr lý phim
const SET_PHIMDANGCHIEU = "SET_PHIMDANGCHIEU";
const SET_PHIMSAPCHIEU = "SET_PHIMSAPCHIEU";
const ALL_PHIM = "ALL_PHIM";
const GET_INFO_MOVIE = "GET_INFO_MOVIE";

// quan ly rap
const SET_MOVIETHEATER = "SET_MOVIETHEATER";
const SET_INFOTHEATER = "SET_INFOTHEATER";
const SET_CHEDULEMOVIE = "SET_CHEDULEMOVIE";

// Quan ly nguoi dung
const SET_ACCOUNTS_USER = "SET_ACCOUNTS_USER";
const SET_HISTORY_BOOKED = "SET_HISTORY_BOOKED";
const GET_LIST_USER = "GET_LIST_USER";
const GET_INFO_USER = "GET_INFO_USER";
const GET_PERSONAL_INFORMATION = "GET_PERSONAL_INFORMATION";

// Quan ly dat ve
const SET_BOOKING_MOVIE = "SET_BOOKING_MOVIE";
const SET_SEAT_BOOKED = "SET_SEAT_BOOKED";
const SET_BOOK_TICKET = "SET_BOOK_TICKET";
const FINISH_BOOKTICKET = "FINISH_BOOKTICKET";
const CHANGE_TABS = "CHANGE_TABS";

// LocalStorage
const USER_ACCOUNT_KEY = "USER_ACCOUNT_KEY";

// display loading action
const DISPLAY_LOADING = "DISPLAY_LOADING";
const HIDE_LOADING = "HIDE_LOADING";

export {
  SET_CAROUSEL,
  SET_MOVIELIST,
  SET_PHIMDANGCHIEU,
  SET_PHIMSAPCHIEU,
  ALL_PHIM,
  SET_MOVIETHEATER,
  SET_INFOTHEATER,
  SET_CHEDULEMOVIE,
  SET_ACCOUNTS_USER,
  USER_ACCOUNT_KEY,
  SET_BOOKING_MOVIE,
  SET_SEAT_BOOKED,
  SET_BOOK_TICKET,
  SET_HISTORY_BOOKED,
  DISPLAY_LOADING,
  HIDE_LOADING,
  FINISH_BOOKTICKET,
  CHANGE_TABS,
  GET_INFO_MOVIE,
  GET_LIST_USER,
  GET_INFO_USER,
  GET_PERSONAL_INFORMATION,
};
